










































import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import anime from "animejs";
import { Route } from "vue-router";
import ContentContainer from "../../components/ContentContainer.vue";
import constants from '../../store/constants';

@Component({
  components: {
    ContentContainer
  }
})
export default class ObjectPageVizualizations extends Vue {
  @Prop() visibleScreenNumber!: number;
  @Prop() activeScreenNumber!: number;
  @Prop() screenNumber!: number;
  @State(state => state.app.loadingScreenAnimationEnded) loadingAnimationEnded!: boolean;
  @State(state => state.app.isTouchscreen) isTouchscreen!: boolean;
  @State(state => state.app.scrollingByScreens) scrollingByScreens!: boolean;

  hoverEventsEnabled = false;
  hoveredElementNumber = 1;

  $refs!: {
    screen: HTMLElement;
    interiorBlock: HTMLElement;
    exteriorBlock: HTMLElement;
    wrap: HTMLElement;
    vizText: HTMLElement;
  };


  @Emit("change-screen")
  changeScreen() { }


  mounted() {
    this.$refs.wrap.style.opacity = "0";
  }

  get screenHeight() {
    return (this.scrollingByScreens) ? this.$browser.height :
      (this.$browser.width < 600) ?
        this.$browser.width * 1.3 : this.$browser.height;
  }

  get containerHeight() {
    let height = (this.scrollingByScreens) ? this.screenHeight - 130 : this.screenHeight - 30
    return height;
  }

  /**************************************/
  /************* Анимации ***************/
  /**************************************/

  alreadyEntered = false;

  /** Предыдущий экран уходит.*/
  @Watch("activeScreenNumber")
  activeScreenNumberChange(nextNumber: number, prevNumber: number) {
    if (prevNumber == this.screenNumber && this.scrollingByScreens) {
      this.screenLeave();
    }
  }

  /** Следующий экран появляется*/
  @Watch("visibleScreenNumber")
  visibleScreenNumberChange(nextNumber: number, prevNumber: number) {
    if (nextNumber == this.screenNumber && (this.scrollingByScreens || !this.alreadyEntered)) {
      this.screenEnter(prevNumber);
      this.alreadyEntered = true;
    }

    if (nextNumber == this.screenNumber) {
      localStorage.setItem("screen", "Визуализации");
    }
  }


  screenEnter(prevScreenNumber: number) {
    let interiorX = (-this.$refs.interiorBlock.offsetWidth - 40) - this.$refs.interiorBlock.offsetLeft;
    let exteriorX = this.$refs.exteriorBlock.offsetWidth + ((this.$refs.wrap.offsetWidth - this.$refs.exteriorBlock.offsetLeft) - this.$refs.exteriorBlock.offsetWidth);
    anime({
      targets: this.$refs.interiorBlock,
      duration: 1000,
      easing: "easeInOutQuad",
      translateX: [interiorX, 0]
    });

    anime({
      targets: this.$refs.exteriorBlock,
      duration: 1000,
      easing: "easeInOutQuad",
      translateX: [exteriorX, 0]
    });

    anime({
      targets: this.$refs.vizText,
      duration: 1000,
      easing: "easeInOutQuad",
      translateY: [-100, 0],
      opacity: [0, 1]
    });

    (anime as any).set(this.$refs.interiorBlock, { opacity: 1 });
    (anime as any).set(this.$refs.exteriorBlock, { opacity: 1 });

    setTimeout(() => {
      this.hoverEventsEnabled = true;
    }, 1200);

    this.$refs.wrap.style.opacity = "1";
  }


  screenLeave() {
    this.hoverEventsEnabled = false;
    anime({
      targets: this.$refs.interiorBlock,
      duration: 700,
      easing: "easeInOutQuad",
      opacity: [1, 0]
    });

    anime({
      targets: this.$refs.exteriorBlock,
      duration: 700,
      easing: "easeInOutQuad",
      opacity: [1, 0]
    });

    anime({
      targets: this.$refs.vizText,
      duration: 700,
      easing: "easeInOutQuad",
      opacity: [1, 0]
    });

    setTimeout(() => {
      this.changeScreen();
    }, 700);
  }


  hover(number: number) {
    if (window.innerWidth > 650 && !this.isTouchscreen && this.hoverEventsEnabled) {
      if (this.hoveredElementNumber == number) return;
      this.hoveredElementNumber = number;
      anime.remove([this.$refs.interiorBlock, this.$refs.exteriorBlock]);
      anime({
        targets: this.$refs.interiorBlock,
        duration: 500,
        easing: "easeOutQuad",
        left: "3%"
      });

      anime({
        targets: this.$refs.exteriorBlock,
        duration: 500,
        easing: "easeOutQuad",
        right: "3%"
      });

      setTimeout(() => {
        if (this.hoveredElementNumber !== number) return;
        this.$refs.interiorBlock.style.zIndex = (number == 2) ? "1" : "2";
        this.$refs.exteriorBlock.style.zIndex = (number == 1) ? "1" : "2";
        anime({
          targets: this.$refs.interiorBlock,
          duration: 500,
          easing: "easeOutQuad",
          left: "6%"
        });

        anime({
          targets: this.$refs.exteriorBlock,
          duration: 500,
          easing: "easeOutQuad",
          right: "6%"
        });
      }, 500)
    }
  }


  click(number: number) {
    if (number == 1) {
      this.$store.dispatch(constants.windowWithSliderContentChange, [
        { id: 1, src: "/visualizations/interior/1.jpg", type: "image", title: "Кухня-гостиная" },
        { id: 2, src: "/visualizations/interior/2.jpg", type: "image", title: "Кухня-гостиная" },

        { id: 4, src: "/visualizations/interior/4.jpg", type: "image", title: "Кухня-гостиная" },
        { id: 5, src: "/visualizations/interior/5.jpg", type: "image", title: "Кухня-гостиная" },
        { id: 6, src: "/visualizations/interior/6.jpg", type: "image", title: "Кухня-гостиная" },
        { id: 7, src: "/visualizations/interior/7.jpg", type: "image", title: "Кухня-гостиная" },

        { id: 9, src: "/visualizations/interior/9.jpg", type: "image", title: "Кабинет" },

        { id: 11, src: "/visualizations/interior/11.jpg", type: "image", title: "Кабинет" },
        { id: 12, src: "/visualizations/interior/12.jpg", type: "image", title: "Кабинет" },
        { id: 13, src: "/visualizations/interior/13.jpg", type: "image", title: "Санузел первого этажа" },

        { id: 15, src: "/visualizations/interior/15.jpg", type: "image", title: "Санузел первого этажа" },
        { id: 16, src: "/visualizations/interior/16.jpg", type: "image", title: "Прихожая" },

        { id: 19, src: "/visualizations/interior/19.jpg", type: "image", title: "Лестница" },



        { id: 23, src: "/visualizations/interior/23.jpg", type: "image", title: "Лестница" },
        { id: 24, src: "/visualizations/interior/24.jpg", type: "image", title: "Родительская спальня" },

        { id: 26, src: "/visualizations/interior/26.jpg", type: "image", title: "Родительская спальня" },
        { id: 27, src: "/visualizations/interior/27.jpg", type: "image", title: "Родительская спальня" },
        { id: 28, src: "/visualizations/interior/28.jpg", type: "image", title: "Гардеробная" },
        { id: 29, src: "/visualizations/interior/29.jpg", type: "image", title: "Гардеробная" },
        { id: 30, src: "/visualizations/interior/30.jpg", type: "image", title: "Детская" },
        { id: 31, src: "/visualizations/interior/31.jpg", type: "image", title: "Детская" },

        { id: 33, src: "/visualizations/interior/33.jpg", type: "image", title: "Детская" },


        { id: 36, src: "/visualizations/interior/36.jpg", type: "image", title: "Спальня" },
        { id: 37, src: "/visualizations/interior/37.jpg", type: "image", title: "Спальня" },

        { id: 39, src: "/visualizations/interior/39.jpg", type: "image", title: "Спальня" },
        { id: 40, src: "/visualizations/interior/40.jpg", type: "image", title: "Санузел второго этажа" },

        { id: 42, src: "/visualizations/interior/42.jpg", type: "image", title: "Санузел второго этажа" }
      ]);
    }

    if (number == 2) {
      this.$store.dispatch(constants.windowWithSliderContentChange, [
        { id: 1, src: "/visualizations/exterior/1.jpg", type: "image", title: "Современная архитектура" },
        { id: 2, src: "/visualizations/exterior/4.jpg", type: "image", title: "Современная архитектура" },
        { id: 3, src: "/visualizations/exterior/5.jpg", type: "image", title: "Современная архитектура" },
        { id: 4, src: "/visualizations/exterior/7.jpg", type: "image", title: "Современная архитектура" },
        { id: 5, src: "/visualizations/exterior/9.jpg", type: "image", title: "Два парковочных места" },
        { id: 6, src: "/visualizations/exterior/10.jpg", type: "image", title: "Просторные дворы с выходом в лес" },
        { id: 7, src: "/visualizations/exterior/11.jpg", type: "image", title: "Просторные дворы с выходом в лес" },
        { id: 8, src: "/visualizations/exterior/12.jpg", type: "image", title: "Просторные дворы с выходом в лес" },
        { id: 9, src: "/visualizations/exterior/13.jpg", type: "image", title: "Терраса и балкон с видом на лес" },
        { id: 10, src: "/visualizations/exterior/14.jpg", type: "image", title: "Терраса и балкон с видом на лес" },
        { id: 11, src: "/visualizations/exterior/15.jpg", type: "image", title: "Терраса и балкон с видом на лес" },
        { id: 12, src: "/visualizations/exterior/17.jpg", type: "image", title: "Современная архитектура" },
      ]);
    }
  }
}
